import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants.js';

const store = {
  namespaced: true,
  state: {
    currencies: [],
    pagination: PAGINATION,
    totalCount: 0,
    count: {},
    coinList: []
  },
  getters: {},
  mutations: {
    setCurrencyList(state, payload) {
      state.currencies = payload.list;
      state.count = payload.count;
      state.totalCount = payload.totalCount;
    },
    setpage(state, page) {
      state.pagination = page;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  actions: {
    list({ commit }, data) {
      return api.getList(data).then(({ data }) => {
        commit('setCurrencyList', data);
      });
    },
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    }
  }
};

appStore.registerModule('recharge', store);
